export default __webpack_public_path__ + "static/psgCard3-d9285787b5ec9a1664adfbdc4627e7b8.webp";